import { Amplify } from 'aws-amplify'

export const APP_PATH = import.meta.env.VITE_APP_PATH || '/race-studio'
export const AWS_REGION = import.meta.env.VITE_AWS_REGION || 'us-west-1'
export const USER_DATA_BUCKET = import.meta.env.VITE_USER_DATA_BUCKET as string

/** True when the Cognito IDs are present; lets the app run parser-only without a backend. */
export const authConfigured = Boolean(
  import.meta.env.VITE_COGNITO_USER_POOL_ID && import.meta.env.VITE_COGNITO_USER_POOL_CLIENT,
)

export type SocialProvider = 'google' | 'facebook' | 'apple'

/** Social providers enabled in Cognito, from the Terraform output baked in at build time. */
export const socialProviders: SocialProvider[] = ((import.meta.env.VITE_SOCIAL_PROVIDERS as string) || '')
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter((s): s is SocialProvider => s === 'google' || s === 'facebook' || s === 'apple')

const OAUTH_PROVIDER_NAMES: Record<SocialProvider, 'Google' | 'Facebook' | 'Apple'> = {
  google: 'Google',
  facebook: 'Facebook',
  apple: 'Apple',
}

export function configureAmplify() {
  if (!authConfigured) return
  const origin = window.location.origin
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
        userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT,
        identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
        loginWith: {
          email: true,
          // Hosted UI: this is the flow social providers use.
          oauth: {
            domain: import.meta.env.VITE_COGNITO_DOMAIN,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [`${origin}${APP_PATH}`],
            redirectSignOut: [origin],
            responseType: 'code',
            providers: socialProviders.map((p) => OAUTH_PROVIDER_NAMES[p]),
          },
        },
        signUpVerificationMethod: 'code',
      },
    },
  })
}
